import Service from "../../../Services/index";

const AdvancePaymentDetails = {
    namespaced: true,
    state: {
        AdvancePaymentDetailsList: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_ADVANCE_PAYMENT_DETAILS: (state, res) => {
            state.AdvancePaymentDetailsList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
    },
    actions: {
        setAdvancePaymentDetails({commit}, page = 1) {
            return Service.AdvancePaymentDetails.getAdvancePaymentDetails(page).then(data => {
                commit("GET_ADVANCE_PAYMENT_DETAILS", data);
            })
        },
        showAdvancePaymentDetailsById({commit}, data) {
            return Service.AdvancePaymentDetails.showAdvancePaymentDetails(data.id, data.page).then(res => {
                commit("GET_ADVANCE_PAYMENT_DETAILS", res);
            })
        },
        saveAdvancePaymentDetails({commit}, {id, data}) {
            if (!id) {
                return Service.AdvancePaymentDetails.createAdvancePaymentDetails(data).then(res => {
                    //console.log('create');
                });
            } else {
                return Service.AdvancePaymentDetails.updateAdvancePaymentDetails(id, data).then(res => {
                    //console.log('update');
                });
            }
        },
        deleteAdvancePaymentDetails({commit}, id) {
            return Service.AdvancePaymentDetails.deleteAdvancePaymentDetails(id);
        },
    }
};
export default AdvancePaymentDetails;
